import logo from "assets/images/hopeedulogo.png";
import { NavPositionContext } from "contexts";
import React, { useContext, useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { Link, useHistory, useLocation } from "react-router-dom";
import { URLPaths } from "utilities";
import "./Navigation.scss";

/** Generating the MapNavigation bar for the map page */

export const navbarHeight = "6rem";

/* These booleans are what alter the Toggle mapView */

export let toggleStudentTeacher: boolean;
export let togglePartnerSchool: boolean;
export let toggleMayTerm: boolean;
export let toggleHopeAlumni: boolean;

export let changeTransition: boolean;

// toggleHopeAlumni = true;
// toggleStudentTeacher = true;

/* This resets the toggles everytime the page changes */
export const resetToggles = () => {
  toggleHopeAlumni = false;
  toggleMayTerm = false;
  togglePartnerSchool = false;
  toggleStudentTeacher = false;
  console.log("resetting toggles");
};

export function MapNavigation({
  keyVal,
  toggleMap,
  setMapZoom,
  setDefaultCenter,
}: {
  keyVal: string;
  toggleMap: React.Dispatch<React.SetStateAction<"true" | "false">>;
  setMapZoom: React.Dispatch<React.SetStateAction<number>>;
  setDefaultCenter: React.Dispatch<
    React.SetStateAction<{
      lat: number;
      lng: number;
    }>
  >;
}): JSX.Element {
  const { navPosition } = useContext(NavPositionContext);
  const [radioValue] = useState();

  const [sChecked, setSChecked] = useState(true);
  const [hChecked, setHChecked] = useState(true);
  const [tChecked, setTChecked] = useState(false);
  const [pChecked, setPChecked] = useState(false);

  const history = useHistory();

  // const handleToggleMap = () => {
  //     toggleMap();
  // };

  // const radios = [
  //   { name: "Student Teacher", value: "student-teacher" },
  //   { name: "MayTerm", value: "may-term" },
  //   { name: "Hope Alumni", value: "hired" },
  //   { name: "Partner School", value: "partner-school" },
  // ];

  /* This is where the real work comes for the nav bar toggle buttons */

  const handleClicked = (event: { target: { checked: boolean; value: string } }) => {
    const { pathname } = window.location;

    if (pathname === "/education-job-openings") {
      // resetToggles();
      changeTransition = true;
      history.push("/map");

      return;
    }

    if (pathname === "/map-view-admin") {
      resetToggles();
      history.push("/map");
      return;
    }

    if (event.target.value === "student-teacher") {
      toggleStudentTeacher = !toggleStudentTeacher;
      changeTransition = false;
      if (toggleMayTerm === true) {
        setMapZoom(3.5);
      }

      if (keyVal === "true") {
        toggleMap("false");
      } else toggleMap("true");
      setSChecked(!sChecked);
    }

    if (event.target.value === "partner-school") {
      togglePartnerSchool = !togglePartnerSchool;
      changeTransition = false;
      if (toggleMayTerm === true) {
        setMapZoom(3.5);
      }

      if (keyVal === "true") {
        toggleMap("false");
      } else toggleMap("true");
      setPChecked(!pChecked);
    }

    if (event.target.value === "may-term") {
      toggleMayTerm = !toggleMayTerm;
      changeTransition = false;
      if (toggleMayTerm) {
        setMapZoom(3.5);
        setDefaultCenter({ lat: 40, lng: -50 });
      } else {
        setMapZoom(8);
        setDefaultCenter({ lat: 42.870859, lng: -83.865036 });
      }
      if (keyVal === "true") {
        toggleMap("false");
      } else {
        toggleMap("true");
        setTChecked(!tChecked);
      }
    }

    if (event.target.value === "hired") {
      toggleHopeAlumni = !toggleHopeAlumni;
      changeTransition = false;
      if (toggleMayTerm === true) {
        setMapZoom(3.5);
      }

      if (keyVal === "true") {
        toggleMap("false");
      } else toggleMap("true");
      setHChecked(!hChecked);
    }
  };

  changeTransition = false;

  return (
      <Navbar
        className="flex-container"
        bg="light"
        fixed={navPosition}
        style={{ height: navbarHeight }}
      >
        <EdImage />
        <div className="togInstruction">Show Me:</div>

        <ToggleButtonGroup type="checkbox" className="toggleBox">
          <ToggleButton
            className="btn btn-primary shadow-none studentTeacherBtn"
            key={radioValue}
            id={`radio-${radioValue}`}
            value="student-teacher"
            checked={sChecked}
            onChange={handleClicked}
          >
            Student Teachers
          </ToggleButton>
          <ToggleButton
            className="btn btn-primary shadow-none hopeAlumniBtn"
            key={radioValue}
            id={`radio-${radioValue}`}
            value="hired"
            checked={hChecked}
            onChange={handleClicked}
          >
            Hope Alumni
          </ToggleButton>
          <ToggleButton
            className="btn btn-primary shadow-none mayTermsBtn"
            key={radioValue}
            id={`radio-${radioValue}`}
            value="may-term"
            checked={tChecked}
            onChange={handleClicked}
          >
            Travel Opportunities
          </ToggleButton>
          <ToggleButton
            className="btn btn-primary shadow-none PartnerBtn"
            key={radioValue}
            id={`radio-${radioValue}`}
            value="partner-school"
            checked={pChecked}
            onChange={handleClicked}
          >
            Partner Schools
          </ToggleButton>
        </ToggleButtonGroup>
        <NavLink path={URLPaths.jobOpeningsFinder} onClick={resetToggles}>
          Job Openings Map
        </NavLink>

        {/* <RNavLinkArrow path={URLPaths.pictureWall} onClick={resetToggles}>
          {" "}
        </RNavLinkArrow> */}

        <ActionNavLink path={URLPaths.edDepInfo} text="Touch To See Ed Department Updates" />

        <ActionNavLink
          path={URLPaths.pictureWall}
          text="Touch To See Our Students, Faculty & Staff"
        />
      </Navbar>
  );
}

type NavLinkProps = {
  path: string;
  children: React.ReactNode;
  onClick: () => void;
};

function NavLink({ path, children, onClick }: NavLinkProps): JSX.Element {
  const { pathname } = useLocation();
  return (
    <Link
      to={path}
      onClick={onClick}
      className={`nav-link ${
        pathname === path ? "active" : ""
      }`} /* onClick={() => logout().then(() => history.push("/"))} */
    >
      {children}
    </Link>
  );
}

// function RNavLinkArrow({ path, children }: NavLinkProps): JSX.Element {
//   const { pathname } = useLocation();
//   return (
//     <Link to={path} id="right-nav-arrow">
//       {children}
//       <button
//         onClick={resetToggles}
//         className={`nav-link-arrow-right  ${pathname === path ? "active" : ""}`}
//       >
//         <BsFillArrowRightCircleFill />
//       </button>
//       <div className="nextFlex">
//         <p className="nextText-long">Pictures</p>
//       </div>
//     </Link>
//   );
// }

function EdImage(): JSX.Element {
  return <img className="edlogo" id="logo" alt="edu" src={logo} />;
}

type ActionNavLinkProps = {
  path: string;
  text: string;
};

function ActionNavLink({ path, text }: ActionNavLinkProps): JSX.Element {
  const { pathname } = useLocation();
  return (
    <Link to={path} className={`action-nav-link ${pathname === path ? "active" : ""}`}>
      <button className="action-button">{text}</button>
    </Link>
  );
}
